"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentVariables = void 0;
var EnvironmentVariables;
(function (EnvironmentVariables) {
    EnvironmentVariables["__IS_CONTACT_CENTER__"] = "__IS_CONTACT_CENTER__";
    EnvironmentVariables["__DEVELOPMENT__"] = "__DEVELOPMENT__";
    EnvironmentVariables["__COUNTRY__"] = "__COUNTRY__";
    EnvironmentVariables["__VARIANT__"] = "__VARIANT__";
    EnvironmentVariables["__ASSETS_PATH__"] = "__ASSETS_PATH__";
    EnvironmentVariables["__BANK_ID__"] = "__BANK_ID__";
    EnvironmentVariables["APPDYNAMICS_APP_KEY"] = "APPDYNAMICS_APP_KEY";
    EnvironmentVariables["ASSETS_SERVER_PATH"] = "ASSETS_SERVER_PATH";
    EnvironmentVariables["BDATA_ANDROID_SEC_URL"] = "BDATA_ANDROID_SEC_URL";
    EnvironmentVariables["BDATA_IOS_BRID_URL"] = "BDATA_IOS_BRID_URL";
    EnvironmentVariables["BDATA_IOS_SEC_URL"] = "BDATA_IOS_SEC_URL";
    EnvironmentVariables["BDATA_WEB_URL"] = "BDATA_WEB_URL";
    EnvironmentVariables["COUNTRY"] = "COUNTRY";
    EnvironmentVariables["DOWNLOAD_ANDROID_APP_URL"] = "DOWNLOAD_ANDROID_APP_URL";
    EnvironmentVariables["DOWNLOAD_IOS_APP_URL"] = "DOWNLOAD_IOS_APP_URL";
    EnvironmentVariables["DYNATRACE_URL"] = "DYNATRACE_URL";
    EnvironmentVariables["ENVIRONMENT"] = "ENVIRONMENT";
    EnvironmentVariables["FRIENDS_FAMILY_ACTIVE"] = "FRIENDS_FAMILY_ACTIVE";
    EnvironmentVariables["KEYCLOAK_AUTH_CLIENTID"] = "KEYCLOAK_AUTH_CLIENTID";
    EnvironmentVariables["KEYCLOAK_AUTH_URL"] = "KEYCLOAK_AUTH_URL";
    EnvironmentVariables["LOGIN_DOMAIN"] = "LOGIN_DOMAIN";
    EnvironmentVariables["LOGIN_URL"] = "LOGIN_URL";
    EnvironmentVariables["MIDDLEWARE_AUTH_BASE_HOST"] = "MIDDLEWARE_AUTH_BASE_HOST";
    EnvironmentVariables["MIDDLEWARE_AUTH_SERVICE_HOST"] = "MIDDLEWARE_AUTH_SERVICE_HOST";
    EnvironmentVariables["MIDDLEWARE_BASE_HOST"] = "MIDDLEWARE_BASE_HOST";
    EnvironmentVariables["MIDDLEWARE_LOGIN_BASE_HOST"] = "MIDDLEWARE_LOGIN_BASE_HOST";
    EnvironmentVariables["MIDDLEWARE_CMS_BASE_HOST"] = "MIDDLEWARE_CMS_BASE_HOST";
    EnvironmentVariables["MIDDLEWARE_DEVICES_BASE_HOST"] = "MIDDLEWARE_DEVICES_BASE_HOST";
    EnvironmentVariables["MIDDLEWARE_PSD2_SCA_BASE_HOST"] = "MIDDLEWARE_PSD2_SCA_BASE_HOST";
    EnvironmentVariables["PRIVATE_WEB_URL"] = "PRIVATE_WEB_URL";
    EnvironmentVariables["PRIVATE_WEB_LOGOUT_URL"] = "PRIVATE_WEB_LOGOUT_URL";
    EnvironmentVariables["MIDDLEWARE_TRANSLATIONS_BASE_HOST"] = "MIDDLEWARE_TRANSLATIONS_BASE_HOST";
    EnvironmentVariables["ONBOARDING_LOGOUT_URL"] = "ONBOARDING_LOGOUT_URL";
    EnvironmentVariables["ONBOARDING_PATH"] = "ONBOARDING_PATH";
    EnvironmentVariables["ONBOARDING_WEB_URL"] = "ONBOARDING_WEB_URL";
    EnvironmentVariables["GOOGLE_API_KEY"] = "GOOGLE_API_KEY";
    EnvironmentVariables["HCAPTCHA_SITE_KEY"] = "HCAPTCHA_SITE_KEY";
    EnvironmentVariables["STATIC_BUILD"] = "STATIC_BUILD";
    EnvironmentVariables["PAY_MY_BILLS_REDIRECTION_URL"] = "PAY_MY_BILLS_REDIRECTION_URL";
    EnvironmentVariables["WEBSOCKET_DOMAIN_URL"] = "WEBSOCKET_DOMAIN_URL";
    EnvironmentVariables["AUTH_SYSTEM"] = "AUTH_SYSTEM";
    EnvironmentVariables["AUTH_CLIENT"] = "AUTH_CLIENT";
    EnvironmentVariables["AUTH_AUTHORITY"] = "AUTH_AUTHORITY";
    EnvironmentVariables["AUTH_REDIRECT_URI"] = "AUTH_REDIRECT_URI";
})(EnvironmentVariables || (exports.EnvironmentVariables = EnvironmentVariables = {}));
//# sourceMappingURL=enviromentVariables.js.map